const React = require('react');
const { View } = require('react-native');

const ViewShot = (props) => React.createElement(View, props);
const captureRef = async () => '';

module.exports = ViewShot;
module.exports.default = ViewShot;
module.exports.captureRef = captureRef;
